import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSchoolCircleCheck, faBookAtlas, faPlusSquare, faEdit, faComment, faRedo, faFistRaised, faGlassMartini, faCartShopping, faShower } from '@fortawesome/free-solid-svg-icons';
import './BPMForce.css';
import bpmforceimage from '../../assets/pageimages/BpmForce.webp';

function BPMForceDMAIC() {
  const items = [
    {
      mainitem: 'Define Phase', path: '/bpmforce-define', icon: 'faSchoolCircleCheck',
      subitems: [
        { subitem: 'Project Charter', path: '/bpmforce-define-charter', icon: 'faBookAtlas',
          subsubitems: [
            {subsubitem: 'Business Case', path: '/bpmforce-define-charter-business-ase', icon: 'faBookAtlas'},
            {subsubitem: 'Problem Statement', path: '/bpmforce-define-charter-problem-statement', icon: 'faBookAtlas'},
            {subsubitem: 'Goal Statement', path: '/bpmforce-define-charter-goal-statement', icon: 'faBookAtlas'},
            {subsubitem: 'Scope List', path: '/bpmforce-define-charter-scope-list', icon: 'faBookAtlas'},
            {subsubitem: 'Project Team', path: '/bpmforce-define-charter-team', icon: 'faBookAtlas'},
            {subsubitem: 'Cost Analysis', path: '/bpmforce-define-charter-cost-analysis', icon: 'faBookAtlas'},
            {subsubitem: 'Plan Outline', path: '/bpmforce-define-charter-plan', icon: 'faBookAtlas'},
            {subsubitem: 'Key Deliverables', path: '/bpmforce-define-charter-key-deliverables', icon: 'faBookAtlas'},
            {subsubitem: 'Assumptions', path: '/bpmforce-define-charter-assumptions', icon: 'faBookAtlas'},
            {subsubitem: 'Risk Planning', path: '/bpmforce-define-charter-risk-planning', icon: 'faBookAtlas'},
            {subsubitem: 'Lessons Learned', path: '/bpmforce-define-charter-lesson-learned', icon: 'faBookAtlas'},
          ] 
        },
        { subitem: 'Project Planning', path: '/bpmforce-define-planning', icon: 'faPlusSquare' },
        { subitem: 'WBS', path: '/bpmforce-define-wbs', icon: 'faEdit' },
        { subitem: 'Gantt Chart', path: '/bpmforce-define-gantt', icon: 'faComment' },
        { subitem: 'Com Plan', path: '/bpmforce-define-communication', icon: 'faRedo' },
        { subitem: 'VOC', path: '/bpmforce-define-voc', icon: 'faFistRaised' },
        { subitem: 'SIPOC', path: '/bpmforce-define-sipoc', icon: 'faGlassMartini' },
        { subitem: 'Project Management Tools', path: '/bpmforce-define-tools', icon: 'faCartShopping' },
      ]
    },
    {
      mainitem: 'Measure Phase', path: '/bpmforce-measure', icon: 'faShower',
      subitems: [
        { subitem: 'Process Map', path: '/bpmforce-measure-map', icon: 'faSchoolCircleCheck' },
        { subitem: 'Value Stream Map', path: '/bpmforce-measure-vsm', icon: 'faBookAtlas' },
        { subitem: 'Box Plots', path: '/bpmforce-measure-boxplots', icon: 'faPlusSquare' },
        { subitem: 'Stem & Leaf Plot', path: '/bpmforce-measure-stemleaf', icon: 'faEdit' },
        { subitem: 'MSA', path: '/bpmforce-measure-msa', icon: 'faComment' },
        { subitem: 'R&R', path: '/bpmforce-measure-rr', icon: 'faRedo' }
      ]
    },
    {
      mainitem: 'Analyse Phase', path: '/bpmforce-analyse', icon: 'faFistRaised',
      subitems: [
        { subitem: '5S', path: '/bpmforce-analyse-5s', icon: 'faGlassMartini' },
        { subitem: 'Value Analysis', path: '/bpmforce-analyse-value', icon: 'faCartShopping' },
        { subitem: 'FMEA', path: '/bpmforce-analyse-fmea', icon: 'faShower' },
        { subitem: '5Whys', path: '/bpmforce-analyse-5whys', icon: 'faSchoolCircleCheck' },
        { subitem: 'DOE', path: '/bpmforce-analyse-doe', icon: 'faBookAtlas' },
        { subitem: 'Pareto', path: '/bpmforce-analyse-pareto', icon: 'faPlusSquare' },
        { subitem: 'Process Map', path: '/bpmforce-analyse-map', icon: 'faEdit' },
        { subitem: 'Cause & Effect', path: '/bpmforce-analyse-causeeffect', icon: 'faComment' },
        { subitem: 'Force Field Analysis', path: '/bpmforce-analyse-forcefield', icon: 'faRedo' },
        { subitem: 'Histogram', path: '/bpmforce-analyse-histogram', icon: 'faFistRaised' },
        { subitem: 'Binomial Dist', path: '/bpmforce-analyse-binomial', icon: 'faGlassMartini' },
        { subitem: 'Normal Dist', path: '/bpmforce-analyse-normal', icon: 'faCartShopping' },
        { subitem: 'Skewness', path: '/bpmforce-analyse-skewness', icon: 'faShower' },
        { subitem: 'Kurtosis', path: '/bpmforce-analyse-kurtosis', icon: 'faSchoolCircleCheck' },
        { subitem: 'Bimodal', path: '/bpmforce-analyse-bimodal', icon: 'faBookAtlas' },
        { subitem: 'Variations', path: '/bpmforce-analyse-variations', icon: 'faPlusSquare' },
        { subitem: 'Corelation', path: '/bpmforce-analyse-corelation', icon: 'faEdit' },
        { subitem: 'Regression', path: '/bpmforce-analyse-regression', icon: 'faEdit' },
        { subitem: 'Hypothesis Testing', path: '/bpmforce-analyse-hypothesis', icon: 'faComment' },
        { subitem: 'ANOVA', path: '/bpmforce-analyse-anova', icon: 'faRedo' }
      ]
    },
    {
      mainitem: 'Improve Phase', path: '/bpmforce-improve', icon: 'faFistRaised',
      subitems: [
        { subitem: 'Stakeholders', path: '/bpmforce-improve-stakeholder', icon: 'faGlassMartini' },
        { subitem: 'Seven Deadly Waste', path: '/bpmforce-improve-waste', icon: 'faCartShopping' },
        { subitem: '5S', path: '/bpmforce-improve-5s', icon: 'faShower' },
        { subitem: 'Benchmarking', path: '/bpmforce-improve-benchmarking', icon: 'faSchoolCircleCheck' },
        { subitem: 'Solution Matrix', path: '/bpmforce-improve-solution', icon: 'faBookAtlas' },
        { subitem: 'DOE', path: '/bpmforce-improve-doe', icon: 'faPlusSquare' },
        { subitem: 'Kaizen', path: '/bpmforce-improve-kaizen', icon: 'faEdit' },
        { subitem: 'Kaizen Blitz', path: '/bpmforce-improve-blitz', icon: 'faComment' },
        { subitem: 'PDCA', path: '/bpmforce-improve-pdca', icon: 'faRedo' },
        { subitem: 'Cost Benefit', path: '/bpmforce-improve-costbenefit', icon: 'faFistRaised' },
      ]
    },
    {
      mainitem: 'Control Phase', path: '/bpmforce-control', icon: 'faGlassMartini',
      subitems: [
        { subitem: 'Control Plan', path: '/bpmforce-control-plan', icon: 'faCartShopping' },
        { subitem: 'Document Control', path: '/bpmforce-control-document', icon: 'faShower' },
        { subitem: 'TPM', path: '/bpmforce-control-tpm', icon: 'faSchoolCircleCheck' },
        { subitem: 'Pkayoke', path: '/bpmforce-control-pkayoke', icon: 'faBookAtlas' },
        { subitem: 'Control Charts - A', path: '/bpmforce-control-charts-attr', icon: 'faPlusSquare' },
        { subitem: 'Control Charts - V', path: '/bpmforce-control-charts-var', icon: 'faEdit' }
      ]
    },
    {
      mainitem: 'PDCA Project', path: '/bpmforce-pdca', icon: 'faFistRaised',
      subitems: [
        { subitem: 'Synopsis', path: '/bpmforce-pdca-synopsis', icon: 'faGlassMartini' },
        { subitem: 'Cover Page', path: '/bpmforce-pdca-cover', icon: 'faCartShopping' },
        { subitem: 'Personal Info', path: '/bpmforce-pdca-info', icon: 'faShower' },
        { subitem: 'Executive Summary', path: '/bpmforce-pdca-summary', icon: 'faSchoolCircleCheck' },
        { subitem: 'Project Methodology', path: '/bpmforce-pdca-methodology', icon: 'faBookAtlas' },
        { subitem: 'Project Selection', path: '/bpmforce-pdca-selection', icon: 'faPlusSquare' },
        { subitem: 'Selection Reasons', path: '/bpmforce-pdca-reasons', icon: 'faEdit' },
        { subitem: 'Project Timeline', path: '/bpmforce-pdca-timeline', icon: 'faComment' },
        { subitem: 'Project Goals', path: '/bpmforce-pdca-goals', icon: 'faRedo' },
        { subitem: 'Action Plans', path: '/bpmforce-pdca-action', icon: 'faFistRaised' },
        { subitem: 'Data Gathering', path: '/bpmforce-pdca-data', icon: 'faGlassMartini' },
        { subitem: 'Data Measurement', path: '/bpmforce-pdca-measurement', icon: 'faCartShopping' },
        { subitem: 'Implementation', path: '/bpmforce-pdca-implementation', icon: 'faShower' },
        { subitem: 'Reflection', path: '/bpmforce-pdca-reflection', icon: 'faSchoolCircleCheck' }
      ]
    },
  ];

  const iconMap = {
    faSchoolCircleCheck: faSchoolCircleCheck,
    faBookAtlas: faBookAtlas,
    faPlusSquare: faPlusSquare,
    faEdit: faEdit,
    faComment: faComment,
    faRedo: faRedo,
    faFistRaised: faFistRaised,
    faGlassMartini: faGlassMartini,
    faCartShopping: faCartShopping,
    faShower: faShower
  };
  
  return (
    <MainLayout>
      <div className="mt-12 py-8 bg-gradient-to-r from-green-600 via-blue-600 to-green-600">
        {/* Image Section */}
        {/* <div className="p-4 flex justify-center">
          <img
            id="bpmforce-id"
            src={bpmforceimage}
            alt="BPMForce"
            className="h-72 w-auto rounded-lg shadow-lg"
          />
        </div> */}
        
        {/* Title */}
        <h2 className="text-2xl font-bold text-white text-center my-4">
          BPMForce - SME Process Management Powerhouse
        </h2>
        
        {/* Grid Section */}
        <div className="px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((item, index) => (
              <div
                key={index}
                className="border-2 border-gray-300 bg-gray-600 rounded-lg shadow-md p-4"
              >
                <h2 className="text-lg font-semibold flex items-center bg-lime-400 text-black p-2 rounded-md">
                  <FontAwesomeIcon className="mr-2" icon={iconMap[item.icon]} />
                  {item.mainitem}
                </h2>
                <ul className="mt-2">
                  {item.subitems.map((subitem, subindex) => (
                    <li key={subindex} className="mb-2 ml-2">
                      <Link
                        className="flex items-center text-white hover:text-gray-200"
                        to={subitem.path}
                      >
                        <FontAwesomeIcon className="mr-2" icon={iconMap[subitem.icon]} />
                        {subitem.subitem}
                      </Link>
                      {subitem.subsubitems && (
                        <ul className="ml-4 border-l-2 border-gray-300 pl-2">
                          {subitem.subsubitems.map((subsubitem, subsubindex) => (
                            <li key={subsubindex} className="mb-2">
                              <Link
                                className="flex items-center text-white hover:text-gray-200"
                                to={subsubitem.path}
                              >
                                <FontAwesomeIcon className="mr-2" icon={iconMap[subsubitem.icon]} />
                                {subsubitem.subsubitem}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default BPMForceDMAIC;
